import React, { useEffect, useState } from 'react';

import css from './TnaGeneralEdit.module.css';
import AddEditForm from '../../../_common/elements/forms/AddEditForm';
import FormData from '../../../_common/elements/forms/FormData';
import FormComment from '../../../_common/elements/forms/FormComent';
import FormButtons from '../../../_common/elements/forms/FormButtons';

import toShort from '../../../../../services/utils/dateParser';

import * as tnaServices from '../../../../../services/tnaServices';
import { Form } from 'react-router-dom';

function TnaGeneralEdit({ tnaData, toggleModal, method, onAdd }) {
    const template = {
        tnaId: tnaData?.tnaId || '',
        tnaNo: tnaData?.tnaNo || '',
        tnaTitle: tnaData?.tnaTitle || '',
        aircraftTypeId: tnaData?.aircraftTypeId || '',
        licenseCategoryId: tnaData?.licenseCategoryId || '',
        tnaDescription: tnaData?.tnaDescription || '',
        tnaPrerequisites: tnaData?.tnaPrerequisites || '',
        tnaTerminalLO: tnaData?.tnaTerminalLO || '',
        tnaReferenceDocuments: tnaData?.tnaReferenceDocuments || '',
        tnaMinAttendance: tnaData?.tnaMinAttendance || '',
        tnaMaxDayHours: tnaData?.tnaMaxDayHours || '',
        tnaRev: tnaData?.tnaRev || '',
        tnaRevDate: tnaData?.tnaRevDate || '',
        tnaCreated: tnaData?.tnaCreated,
        tnaModified: tnaData?.tnaModified,
    };
    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing

    const [data, setData] = useState(tnaData || template);
    const [newData, setNewData] = useState(template);
    const [options, setOptions] = useState({ aircraftTypes: [], licenseCategories: [] });

    useEffect(() => {
        (async () => {
            try {
                const [lic, aircraft] = await Promise.all([
                    tnaServices.getOption('getAllLicenseCategories'),
                    tnaServices.getOption('getAllAircraftTypes'),
                ]);
                setOptions({
                    licenseCategories: lic.data,
                    aircraftTypes: aircraft.data,
                });
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        })();
    }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;

        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
    };

    const onAddStay = (e) => {
        handleSubmit(e);
        setNewData((state) => template);
    };

    const onAddClose = (e) => {
        let pass = handleSubmit(e);
        if (pass) {
            toggleModal();
        }
    };
    // ###############################################
    // check before using
    const handleSubmit = async (e) => {
        e.preventDefault();
        tnaServices
            .create(newData)
            .then((result) => {
                console.log(result);
                setNewData((prevDate) => template);
                setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                onAdd(newData);
                return true;
            })
            .catch((err) => {
                // console.log(err);
                setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
                console.log(message); //check why colors are not changing
                return false;
            });
    };
    // ###############################################

    const onEdit = (e) => {
        e.preventDefault();
        const updateData = newData;
        updateData._id = data.tnaId;

        tnaServices
            .edit(updateData)
            .then((res) => {
                setMessage({
                    message: `${updateData.tnaModuleNo} is updated successfully!`,
                    color: 'green',
                });
                toggleModal();
            })
            .catch((err) => {
                setMessage({ message: err.message || 'Unknown error ...', color: 'red' });
            });
    };

    return (
        <AddEditForm>
            <FormData>
                <label className={css.label} htmlFor="tnaTitle">
                    Title:{' '}
                </label>
                <input
                    className={css.input}
                    type="text"
                    id="tnaTitle"
                    value={newData.tnaTitle}
                    onChange={handleChange}
                />
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <label className={css.label} htmlFor="tnaNo">
                            No.:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="text"
                            id="tnaNo"
                            value={newData.tnaNo}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label className={css.label} htmlFor="licenseCategoryId">
                            Cat:{' '}
                        </label>
                        <select
                            className={css.select}
                            id="licenseCategoryId"
                            value={newData.licenseCategoryId}
                            onChange={handleChange}
                        >
                            <option value="">Select License Category</option>
                            {options.licenseCategories?.map((category) => (
                                <option key={category.licenseCategoryId} value={category.licenseCategoryId}>
                                    {category.licenseCategoryTitle}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <label className={css.label} htmlFor="aircraftTypeId">
                    Aircraft:{' '}
                </label>
                <select
                    className={css.select}
                    id="aircraftTypeId"
                    value={newData.aircraftTypeId}
                    onChange={handleChange}
                >
                    <option value="">Select Aircraft</option>
                    {options.aircraftTypes?.map((aircraft) => (
                        <option key={aircraft.aircraftTypeId} value={aircraft.aircraftTypeId}>
                            {aircraft.aircraftTypeTitle}
                        </option>
                    ))}
                </select>
                <div></div>

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <label className={css.label} htmlFor="tnaMinAttendance">
                            Min attendace (%):{' '}
                        </label>
                        <input
                            className={css.input}
                            type="number"
                            id="tnaMinAttendance"
                            value={newData.tnaMinAttendance}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label className={css.label} htmlFor="tnaMaxDayHours">
                            Max day hours:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="text"
                            id="tnaMaxDayHours"
                            value={newData.tnaMaxDayHours}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <label htmlFor="tnaPrerequisites">TNA Prerequisites</label>
                <textarea
                    id="tnaPrerequisites"
                    className={css.textarea}
                    rows="4"
                    onChange={handleChange}
                    value={newData.tnaPrerequisites}
                ></textarea>
                <label htmlFor="tnaReferenceDocuments">Reference Documents</label>
                <textarea
                    id="tnaReferenceDocuments"
                    className={css.textarea}
                    rows="4"
                    onChange={handleChange}
                    value={newData.tnaReferenceDocuments}
                ></textarea>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <label className={css.label} htmlFor="tnaRev">
                            Rev:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="number"
                            id="tnaRev"
                            value={newData.tnaRev}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label className={css.label} htmlFor="tnaRevDate">
                            Rev date:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="text"
                            id="tnaRevDate"
                            value={newData.tnaRevDate}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </FormData>
            <FormComment>
                <label htmlFor="tnaDescription">Description</label>
                <textarea
                    id="tnaDescription"
                    className={css.textarea}
                    rows="4"
                    onChange={handleChange}
                    value={newData.tnaDescription}
                ></textarea>
                <label htmlFor="tnaTerminalLO">Terminal Learning Objectives</label>
                <textarea
                    id="tnaTerminalLO"
                    className={css.textarea}
                    rows="6"
                    onChange={handleChange}
                    value={newData.tnaTerminalLO}
                ></textarea>
                <label htmlFor="tnaModuleNote">Notes</label>
                <textarea
                    id="tnaModuleNote"
                    className={css.textarea}
                    rows="11"
                    onChange={handleChange}
                    value={newData.tnaModuleNote}
                >
                    {/* {newData.tnaModuleNote} */}
                </textarea>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <label className={css.label} htmlFor="tnaCreated">
                            Created:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="date"
                            id="tnaCreated"
                            value={toShort(newData.tnaCreated, 1)}
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                    <div>
                        <label className={css.label} htmlFor="tnaModified">
                            Modified:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="date"
                            id="tnaModified"
                            value={toShort(newData.tnaModified, 1)}
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                </div>
            </FormComment>
            <FormButtons>
                {method === 'add' && (
                    <div className={css.submitButtons}>
                        <button className={css.greenButton} onClick={onAddStay}>
                            Add Module and stay
                        </button>
                        <button className={css.greenButton} onClick={onAddClose}>
                            Add Module and close
                        </button>
                    </div>
                )}
                {method === 'edit' && (
                    <div className={css.submitButtons}>
                        <button className={css.orangeButton} onClick={onEdit}>
                            Edit Module
                        </button>
                    </div>
                )}
                <button onClick={toggleModal} className={`${css.redButton} ${css.buttonClose}`}>
                    Cancel
                </button>
            </FormButtons>
        </AddEditForm>
    );
}
export default TnaGeneralEdit;
